import React, { useRef, useMemo, useEffect } from "react"
import { debounce } from "lodash"
import { Flex } from "@chakra-ui/react"
import { matchPath, useHistory } from "react-router-dom"
import { useEventGuestPaths } from "utilities/routes"
import { DioboxEvent } from "sharedTypes"
import Search from "../Search"

type Props = {
  loading: boolean;
  searchString: string;
  onSearch: (query: string) => void;
  clearSelectedGuestOnSearch?: boolean;
  width?: string;
  event: DioboxEvent;
}

const Searchbar = ({
  loading,
  searchString,
  onSearch,
  clearSelectedGuestOnSearch = true,
  width = "320px",
  event,
}: Props) => {
  const history = useHistory()
  const { eventGuestsPath } = useEventGuestPaths()

  const searchRef = useRef({
    onSearch, clearSelectedGuestOnSearch, history, eventGuestsPath, event,
  })
  searchRef.current = {
    onSearch, clearSelectedGuestOnSearch, history, eventGuestsPath, event,
  }

  const debouncedSearchGuests = useMemo(
    () => debounce((query: string) => {
      const {
        onSearch: search,
        clearSelectedGuestOnSearch: clearSelected,
        history: hist,
        eventGuestsPath: guestsPath,
        event: evt,
      } = searchRef.current
      search(query)
      if (
        clearSelected
        && matchPath(hist.location.pathname, "/events/:eventId/guests/:guestId")
      ) {
        hist.push(guestsPath(evt.id))
      }
    }, 400),
    [],
  )

  useEffect(() => () => debouncedSearchGuests.cancel(), [debouncedSearchGuests])

  return (
    <Flex
      justify="space-between"
      align="center"
      borderWidth={1}
      borderRadius="md"
      pos="relative"
      py={0}
      w={width}
      minW="200px"
      px={2}
      h={10}
    >
      <Search
        onSearch={debouncedSearchGuests}
        value={searchString}
        loading={loading}
      />
    </Flex>
  )
}

export default Searchbar
